// getters
const getters = {
	serverUrl: state => process.env.NODE_ENV === "development" ? "http://localhost:9570/server" : `${window.location.origin}/server`
};

export default {
	namespaced: true,
	getters
};
